import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { MessageService } from 'primeng/api';
import { DocumentService } from '../../../app/document/services/document.service';
import { DocumentDetailDto } from '../../../app/shared/models/document-details-dto';
import { ChangeRequestConstants } from '../change-request.constants';
import { ChangeRequestItem } from '../models/change-request-item';
import { RejectChangeRequestItem } from '../models/reject-change-request-item';
import { UpdateChangeRequestItem } from '../models/update-change-request-item';
import { ChangeRequestItemService } from '../services/change-request-item.service';
import {ChangeRequestPeriodicReviewdata} from '../models/change-request-item-update-periodicReview-data-model';
import { DocumentPersistenceService } from '../../document/services/document-persistence.service';
import { forkJoin, switchMap } from 'rxjs';

@Component({
  selector: 'app-reject-periodic-change-request-item-modal',
  templateUrl: './reject-periodic-change-request-item-modal.component.html',
  styleUrls: ['./reject-periodic-change-request-item-modal.component.scss']
})
export class RejectPeriodicChangeRequestItemModalComponent implements OnInit {

 reviewDate:any
  minDateValue:Date= new Date();
  reviewerComment!:string;
  @Input() isRejectPeriodicChangeRequestModal!:boolean;
  @Output() isRejectPeriodicChangeRequestModalVisible=new EventEmitter<boolean>();
  @Input() selectedItems!:ChangeRequestItem[];
  @Input() periodicReviewDate!:any;
  errorMessages: string[] = [];
  mandatoryFields = this.getDefaultMandatoryFields();
  rejectChangeRequestItem!:RejectChangeRequestItem;
  @Input() documentDetails!:DocumentDetailDto;
  @Input() isLatestVersion!:boolean;
  changeRequestPeriodicReviewdata!:ChangeRequestPeriodicReviewdata;
  readonly periodicReviewCRIStaticMessageForModal=ChangeRequestConstants.Periodic_ReviewCRI_Static_Message_For_Modal;
  readonly errorMessageConstant=ChangeRequestConstants.error_message_constant;

  constructor(private changeRequestItemService: ChangeRequestItemService,private messageService: MessageService,private documentService:DocumentService, private documentPersistenceService : DocumentPersistenceService) { }

  ngOnInit(): void {
    this.setPeriodicReviewdateForModal();
  }
  ngOnChanges(changes: SimpleChanges) {
      if (this.isRejectPeriodicChangeRequestModal) {
        this.setPeriodicReviewdateForModal();
    }

  }

setPeriodicReviewdateForModal()
{
  this.selectedItems.forEach(element => {
    this.changeRequestItemService.getPeriodicReviewdateForDocumentVersion(element.documentNumber,element.documentVersion)
    .subscribe((changeRequestItemsData) => {
      this.reviewDate=new Date(Date.parse(changeRequestItemsData.toString()));
  });
  this.minDateValue.setDate(new Date().getDate() + 1);
});
}

 addDays = (date: Date, days: number): Date => {
  let result = new Date(date);
  result.setDate(result.getDate() + days);
  return result;
};

getDefaultMandatoryFields() {
  return {
    reviewDate: false,
  }
}
  confirmPeriodicChangeRequestRejection():void{
    this.errorMessages=[];
    this.validateRejectChangeRequestModalControls();
    if(this.errorMessages.length === 0){
      this.rejectChangeRequestItem = {
        reasonForRejection: ChangeRequestConstants.RejectionReasonForPeriodicChangeRequestItem,
        reviewerComment: this.reviewerComment
      }
      let crItems:UpdateChangeRequestItem[]=[]; 
      this.selectedItems.forEach(x=>{
        crItems.push({
          changeRequestItemNumber:this.documentDetails.number+"-v"+x.documentVersion+"-"+x.changeRequestItemNumber,
          status:ChangeRequestConstants.RejectedStatus,
          reasonForRejection:ChangeRequestConstants.RejectionReasonForPeriodicChangeRequestItem,
          rejectionComments:this.reviewerComment,
          isLatestVersion:this.isLatestVersion,
          documentNumber:this.documentDetails.number,
          documentVersion:this.documentDetails.version,
          periodicReviewDate: this.documentPersistenceService.conversionOfDateIntoLocalDateTime(new Date(this.reviewDate)),
          description:null,
          changeRequestItemType: x.changeRequestItemType || ''
        })
      })

      const periodicReviewObservables = crItems.map(element => {
        this.changeRequestPeriodicReviewdata = {
          periodicReviewDate: element.periodicReviewDate
        };
        return this.documentService.setPeriodicReviewDateForChangeRequestItem(
          element.documentNumber,
          element.documentVersion,
          this.changeRequestPeriodicReviewdata,
          true
        );
      });

      forkJoin(periodicReviewObservables).pipe(
        switchMap(() => this.changeRequestItemService.updateChangeRequestItems(crItems))
      ).subscribe({
        complete: () => {
          this.messageService.add({
            severity: ChangeRequestConstants.Severity_Info,
            summary: `${ChangeRequestConstants.ChangeRequestItemRejected_success}`
          });
          this.isRejectPeriodicChangeRequestModal = false;
          this.isRejectPeriodicChangeRequestModalVisible.emit(this.isRejectPeriodicChangeRequestModal);
          this.documentPersistenceService.reloadDocumentData(true);
        }
      });
    }
  }


  private validateRejectChangeRequestModalControls(){
    if(this.reviewDate===null || this.reviewDate ===undefined){
          this.mandatoryFields.reviewDate = true;
          this.errorMessages.push(ChangeRequestConstants.PeriodicReviewDateRequiredErrorMessage); 
    }
  }
  cancel():void{
    this.isRejectPeriodicChangeRequestModal=false;
    this.isRejectPeriodicChangeRequestModalVisible.emit(this.isRejectPeriodicChangeRequestModal);
    this.errorMessages=[];
    this.reviewerComment="";
  }
}
